@if (bannersLogin.length === 0) {
<div
  class="container background-image"
  style='background-image: url("assets/images/login_fundo.png")'
>
  <div></div>
  <div class="content">
    <app-card-login></app-card-login>
  </div>
  <div></div>
</div>
}

@if (bannersLogin.length > 0) {
<div class="container-com-banner">
  <div class="banner-section">
    <app-banner-carrossel
      [banners]="bannersLogin"
      [intervaloMs]="tempoSlideBanners">
    </app-banner-carrossel>
  </div>
  <div class="login-section">
    <app-card-login></app-card-login>
  </div>
</div>
}
